export default "__VITE_ASSET__WkGIvHMm__"